module.exports = "<div class=\"full\">\n    <i class=\"fa fa-circle-o-notch fa-spin fa-5x fa-fw spinner-icon\"></i>\n</div>\n  \n  "